import React from 'react';
import PropTypes from 'prop-types';
import { Select as AntSelect, Form } from 'antd';
import isBoolean from 'lodash/isBoolean';

const Select = (props) => (
  <Form.Item
    colon={false}
    required={props.required}
    label={props.label}
    help={props.errorText}
    validateStatus={props.errorText && 'error'}
    style={props.formItemStyle}
  >
    <AntSelect
      allowClear={props.allowClear}
      style={{
        width: '100%',
      }}
      showSearch={props.showSearch}
      placeholder={props.placeholder}
      disabled={props.disabled}
      value={!props.value ? (isBoolean(props.value) ? props.value : undefined) : props.value}
      onChange={(value) => props.onChange && props.onChange(value)}
      mode={props.mode}
      filterOption={props.filterOption}
      onSearch={props.onSearch}
      loading={props.loading}
      {...(props.mode === 'tags' && !props.options.length && { open: false })}
      tokenSeparators={props.tokenSeparators}
    >
      {props.options.map((option) => (
        <AntSelect.Option key={`option-${option.value}`} value={option.value} disabled={option.disabled || false}>
          {option.label}
        </AntSelect.Option>
      ))}
    </AntSelect>
  </Form.Item>
);

Select.propTypes = {
  allowClear: PropTypes.bool,
  label: PropTypes.node,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      disabled: PropTypes.bool,
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, PropTypes.arrayOf(PropTypes.string)]),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  mode: PropTypes.oneOf(['default', 'multiple', 'tags']),
  showSearch: PropTypes.bool,
  placeholder: PropTypes.string,
  errorText: PropTypes.string,
  filterOption: PropTypes.func,
  formItemStyle: PropTypes.object,
  tokenSeparators: PropTypes.arrayOf(PropTypes.string),
};

Select.defaultProps = {
  allowClear: true,
  label: null,
  disabled: false,
  required: false,
  options: [],
  mode: 'default',
  showSearch: false,
  value: null,
  errorText: null,
  filterOption: null,
  placeholder: '',
  formItemStyle: {},
  tokenSeparators: [';', ','],
};

export default Select;
